import type { IntlShape } from 'react-intl';

import { ErrorKeySet, type ValidationError, type Validator } from '../../../types/field-validation';
import type { FormFieldValidation } from '../../../types/form/form-fields';
import type { TextValue } from '../../../types/form/form-fields/field-values';
import { getTextValidationErrors } from '../text';
import { getFailedValidationError } from '../utils';
import { messages } from './messages';

const urlRegex =
	/((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|[a-z0-9.-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()[\]{};:'".,<>?«»“”‘’]))/;

export const getUrlFormatErrors = (intl?: IntlShape, textValue?: TextValue): ValidationError[] => {
	const text = textValue?.text?.trim();
	if (text && !urlRegex.test(text)) {
		return [
			getFailedValidationError(ErrorKeySet.INVALID, intl?.formatMessage(messages.invalidUrl)),
		];
	}
	return [];
};

export const getUrlValidationErrors = (
	validation: FormFieldValidation,
	fieldLabel: string,
	intl?: IntlShape,
	textValue?: TextValue,
): ReturnType<Validator> => {
	if (textValue) {
		const { text } = textValue;
		const trimmedText = text.trim();

		if (!urlRegex.test(trimmedText)) {
			return [
				getFailedValidationError(ErrorKeySet.INVALID, intl?.formatMessage(messages.invalidUrl)),
			];
		}
	}

	return getTextValidationErrors(validation, fieldLabel, intl, textValue);
};
